export function resolveVariableIds(editorContent, subjects, allVariables) {
  const raw = [editorContent, ...(subjects ?? [])].join(' ');
  const stripped = raw.replace(/<[^>]+>/g, ' ');
  const names = new Set([...stripped.matchAll(/\{\{([^}]+)\}\}/g)].map((m) => m[1]));
  return (allVariables ?? [])
    .filter((v) => names.has(String(v?.name ?? '')))
    .map((v) => v.id)
    .filter((id) => id != null);
}
